const tryJsonParse = (value: any) => {
    let maybeJson;
    let isJsonString = true;
    try {
        maybeJson = JSON.parse(value);
    } catch (e) {
        console.error(e);
        isJsonString = false;
    }

    return {
        isJsonString,
        parsedJson: maybeJson,
    };
};

export { tryJsonParse };
